import { useEffect, useState } from 'react';
import { OrderList } from 'primereact/orderlist';
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';

export const ActividadesOrden = ({ matrizId, toast, permss, generic, onClose }) => {
    const [actividades, setActividades] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingGuardarOrden, setLoadingGuardarOrden] = useState(false);
    const matrizSrv = new MonitoreoService();

    useEffect(() => {
        if (matrizId) { loadData(); }
    }, [matrizId]);

    const loadData = () => {
        setLoading(true);
        matrizSrv.consultarInfo('matriz-riesgo-detalle/actividad-orden', { id: matrizId }).then(res => {
            setActividades(res.data);
            setLoading(false);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        }).finally(() => {
            setLoading(false);
        });
    };

    const guardarOrden = () => {
        setLoadingGuardarOrden(true);
        const data = {
            matrizId: matrizId,
            ordenes: actividades.map((item, index) => ({ det_id: item.id, orden: index + 1 }))
        };
        matrizSrv.editar(data, 'matriz-riesgo-detalle/actualizar-orden').then(() => {
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Orden actualizado correctamente.' });
            onClose();
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        }).finally(() => {
            setLoadingGuardarOrden(false);
        });
    };

    const itemTemplate = (item) => {
        const nuevoOrden = actividades.findIndex(a => a.id === item.id) + 1;
        const ordenCambio = item.orden !== nuevoOrden;

        return (
            <div className="actividad-item" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                    <div><strong>{item.actividad}</strong></div>
                    <div><small>{item.sigla_riesgo} - {item.estado}</small></div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '1.5rem', fontWeight: 'bold', color: '#444' }}>
                    {ordenCambio ? (
                        <>
                            <span>{item.orden}</span>
                            <i className="pi pi-sync" style={{ color: '#2196f3' }}></i>
                            <span>{nuevoOrden}</span>
                        </>
                    ) : (
                        <span>{item.orden}</span>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div>
            {loading ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '300px', color: '#444', fontWeight: '500', fontSize: '1.2rem' }}>
                    <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth={5} />
                    <span style={{ marginTop: '1rem' }}>Cargando actividades...</span>
                </div>
            ) : (
                <OrderList value={actividades} onChange={(e) => setActividades(e.value)} itemTemplate={itemTemplate} header="Lista de actividades" dragdrop />
            )}

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '1rem' }}>
                <Button label="Cerrar" icon="pi pi-times" className="p-button-secondary" onClick={onClose} />
                <Button label={loadingGuardarOrden ? "Guardando..." : "Guardar cambios"} icon="pi pi-check" className="p-button-success" onClick={guardarOrden} disabled={loadingGuardarOrden} />
            </div>
        </div>
    );
};